import { IIcon } from '../../model/icon';

export const reply: IIcon = {
  id: `REPLY`,
  svg: `<path fill="#828282" d="M5.8 5.2V3L1.8 7l4 4V8.8c3 0 5 1 6.5 3-.6-3-2.4-5.9-6.5-6.5z" />`
};
